import { render, staticRenderFns } from "./NeuralIconBlack.vue?vue&type=template&id=3aa3e2dc&"
import script from "./NeuralIconBlack.vue?vue&type=script&lang=js&"
export * from "./NeuralIconBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports